import { DateRangePickerValue } from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';

export type MaybeDateRange = (DateRangePickerValue | undefined)[] | undefined;

/**
 * Проверяет, задана ли хотя бы одна граница диапазона дат.
 *
 * @example
 * isDateRangeApplied([1735689600000, null]) // → true
 * isDateRangeApplied([null, null]) // → false
 */
export function isDateRangeApplied(dateRange: MaybeDateRange): boolean {
  return Boolean(dateRange?.[0] || dateRange?.[1]);
}
